import { useQuery } from '@tanstack/react-query';

import type { User } from '@models/user';

import { getMe, getUser, getUsers } from './api';

export function useMeQuery(shouldRefetch?: boolean) {
  return useQuery<User>({
    queryKey: ['me'],
    queryFn: getMe,
    staleTime: 5 * 60 * 1000,
    enabled: shouldRefetch,
  });
}

export function useUserQuery(id: string) {
  return useQuery<User>({
    queryKey: ['user', id],
    queryFn: () => getUser(id),
  });
}

export function useUsersQuery() {
  return useQuery<User[]>({
    queryKey: ['users'],
    queryFn: getUsers,
  });
}
